<dx-button
  *ngIf="status != null"
  stylingMode="text"
  [type]="statusColors[status]"
  [width]="120">
  {{statusNames[status]}}
</dx-button>
